<template>
  <div class="sfboxl2">
    <div class="wfull">
        <div class="hotfbox">
            <div id="contentbox" class="after-sales-wfull-left1">
                <div class="after-sales-wfull-left1-head">
                    <div class="terart">
                        <p>产品分类</p>
                    </div>
                    <div class="terartboto">您所在的位置：产品中心 > <a href="javascript:void" rel="category tag">产品分类</a></div>
                </div>

                                <div class="article">
                    <div id="div1" class="article-left">
                        <span>阻燃剂</span>
                    </div>
                    <div class="article-center">
                        <div class="artcen-left">

                        </div>
                        <div class="artcen-right">
                            <h2><a href="javascript:void" title="氢氧化铝（KH-101、KH-101LC）">氢氧化铝（KH-101）</a></h2>
                             <h2><a href="javascript:void" title="氢氧化铝（KH-101、KH-101LC）">氢氧化铝（KH-101LC）</a></h2>
                            <h2><a href="javascript:void" title="氢氧化镁（K-6）">氢氧化镁（K-6）</a></h2>
                            <h2><a href="javascript:void" title="三氧化二锑">三氧化二锑</a></h2>
                            <h2><a href="javascript:void" title="磷氮系阻燃剂">磷氮系阻燃剂</a></h2>
                        </div>

                    </div>
                    <div class="article-right">
                        <router-link to="/details" class="radios"> > </router-link>
                    </div>
                </div>
                                <div class="article">
                    <div id="div2" class="article-left">
                        <span>橡胶</span>
                    </div>
                    <div class="article-center">
                        <div class="artcen-left">

                        </div>
                        <div class="artcen-right">
                            <h2><a href="javascript:void" title="粉末丁腈橡胶">粉末丁腈橡胶</a></h2>
                        </div>

                    </div>
                    <div class="article-right">
                        <router-link to="/details" class="radios"> > </router-link>
                    </div>
                </div>

                <div class="article">
                    <div id="div3" class="article-left">
                        <span>加工剂</span>
                    </div>
                    <div class="article-center">
                        <div class="artcen-left">

                        </div>
                        <div class="artcen-right">
                            <h2><a href="javascript:void" title="硅酮">硅酮</a></h2>
                            <h2><a href="javascript:void" title="硅油">硅油</a></h2>
                            <h2><a href="javascript:void" title="抗氧剂">抗氧剂</a></h2>
                            <h2><a href="javascript:void" title="紫外线吸收剂">紫外线吸收剂</a></h2>
                            <h2><a href="javascript:void" title="钛白粉">钛白粉</a></h2>      
                        </div>

                    </div>
                    <div class="article-right">
                        <router-link to="/details" class="radios"> > </router-link>
                    </div>
                </div>
                

                <div class="tec-page-nav"></div>
            </div>

        </div>
    </div>

    <div class="clear">
    </div>
</div>
</template>

<script>
export default {
  name: 'hello',
  data () {
    return {
      msg: 'Welcome to Your Vue.js App'
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
 p{
    text-indent:2em;
  }
</style>



// WEBPACK FOOTER //
// Product.vue?1b0b4e16